import { Component, Fragment } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import "./automationBuilder.scss";

import {
  DKLabel,
  showAlert,
  showToast,
  TOAST_TYPE,
  DKButton,
  DKSpinner,
  DKIcon,
  showLoader,
  removeLoader
} from "deskera-ui-library";

import AddTriggerPopup from "./components/AddTriggerPopup";
import AddActionPopup from "./components/AddActionPopup";
import DocumentSelection from "./components/DocumentSelection";
import Step from "./components/Step";
import AutomationManager from "./AutomationManager";
import {
  AUTOMATION_ELEMENT,
  AUTOMATION_ACTIONS,
  AUTOMATION_TRIGGERS,
  UNSUPPORTED_SPLIT_CONTEXT_ACTIONS,
  SPLIT_ACTION_TYPE_CONTEXT,
  SPLIT_ACTION_TYPE,
  SUPPORTED_ASSIGN_ACCESS_ELEMENTS,
  DIRECT_CHILD_ACTION_TYPES,
  SUPPORTED_APPROVAL_CONDITIONS_ACTIONS,
} from "./AutomationConstants";
import EmailComposer from "./components/EmailComposer";
import WaitEditor from "./components/WaitEditor";
import Utility from "../../utility/Utility";
import SavePopup from "../common/SavePopup";
import AutomationService from "../../services/automation";
import { COLUMN_CODE, TABLES } from "../../managers/TableManger";
import FieldMapper from "./components/FieldMapper";
import { PipelineManager } from "../../managers/PipelineManager";
import SplitActionPopup from "./components/SplitActionPopup";
import DocCopyManager from "../../managers/DocCopyManager";
import MessageComposer from "./components/MessageComposer";
import AssignAccessActionPopup from "./components/AssignAccessActionPopup";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import i18next from "i18next";
import StageChangeTriggerPopup from "./components/StageChangeTriggerPopup";
import { JobPipelineManager } from "../../managers/JobPipelineManager";
import InvoiceCommissionAction from "./components/InvoiceCommissionAction";
import { INVITE_USER_STATUS } from "../../constants/Permission";
import ApprovalActionPopup from "./components/ApprovalCondition";
import TenantManager from "../../managers/TenantManager";
import CompanyDetailService from "../../services/CompanyDetailService";
import { DATE_FORMAT } from "../../constants/Constant";
import  DateAlertCriteriaPopup from "./components/DateAlertCriteriaPopup";
import { connect } from "react-redux";
import EmployeeManager, { getReportingManagerOptions } from "../add-employee/steps/Employee";
import { fetchEmployeeListWithoutFilter } from "../../Redux/Slices/EmployeeListSlice";

class AutomationBuilder extends Component {
  parentStepData
  constructor(props) {
    super(props);

    const copyData = DocCopyManager.getData();
    copyData && AutomationManager.setNewAutomationData(copyData);

    this.state = {
      needAddTriggerPopup: false,
      needAddActionPopup: false,
      needSplitOptionPopup: false,
      needEmailComposer: false,
      needMessageComposer: false,
      needFieldMapperPopup: false,
      needAssignAccessPopup: false,
      needWaitEditor: false,
      needSavePopup: false,
      showLoader: true,
      needStageChangeTrigger: false,
      steps: AutomationManager.getAllSteps(),
      adjacencyMatrix: AutomationManager.getAdjacencyMatrix(),
      needCalculateCommissionPopup: false,
      needApprovalActionPopup: false,
      needDateAlertCriteriaPopup: false
    };

    this.setBuilderProperties();
    this.setRequiredSplitProperties();

    // note: this will use later
    // if(Utility.isEmpty(Store.getState().payroll?.formData?.userWithTeams?.users)) {
    //   Store.dispatch(fetchUsersListWithTeams())
    // }
    
    // if (Utility.isEmpty(Store.getState().payroll?.formData?.userWithExpenseGroup?.content) ) {
    //   Store.dispatch(fetchUsersExpenseGroup())
    // }
    
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  componentDidMount() {
    RouteManager.setPresenter(this);
    PipelineManager.get().then(() => { });
    JobPipelineManager.get().then(() => { });
    if (!AutomationManager.isDataAvailable() && this.props.match.params.id) {
        this.setState({ steps: [], adjacencyMatrix: [] });
        AutomationManager.fetchPageDataById(this.props.match.params.id, () => {
            if (AutomationManager.getAllSteps().some((step) => step.type === AUTOMATION_ACTIONS.CREATE_DEAL || step.type === AUTOMATION_ACTIONS.UPDATE_DEAL)) {
                this.setState({ showLoader: true });
                PipelineManager.get().then(() => {
                    this.setState({
                        steps: AutomationManager.getAllSteps(),
                        adjacencyMatrix: AutomationManager.getAdjacencyMatrix(),
                        showLoader: false,
                    });
                });
            } else if (AutomationManager.getAllSteps().some((step) => step.type === AUTOMATION_ACTIONS.SEND_EMAIL)) {
                this.setState({ showLoader: true });
                JobPipelineManager.get().then(() => {
                    this.setState({
                        steps: AutomationManager.getAllSteps(),
                        adjacencyMatrix: AutomationManager.getAdjacencyMatrix(),
                        showLoader: false,
                    });
                });
            } else {
                this.setState({
                    steps: AutomationManager.getAllSteps(),
                    adjacencyMatrix: AutomationManager.getAdjacencyMatrix(),
                    showLoader: false,
                });
            }
        });
    } else {
        this.hideUnHideLoader();
    }

    this.scrollElementIntoView(0, "start", "center");
  }

  componentWillUnmount() {
    AutomationManager.setData(null);
  }

  scrollElementIntoView(
    stepIndex,
    verticalAlignment = "nearest",
    horizontalAlignment = "nearest"
  ) {
    const stepElement = document.getElementById(`auto-step-${stepIndex}`);
    stepElement?.scrollIntoView({
      behavior: "smooth",
      block: verticalAlignment,
      inline: horizontalAlignment,
    });
  }

  refreshData() {
    this.setState({
      steps: AutomationManager.getAllSteps(),
      adjacencyMatrix: AutomationManager.getAdjacencyMatrix(),
    });

    /* Resetting builder properties */
    this.setBuilderProperties();
  }

  setBuilderProperties = () => {
    this.stepIndexToUpdate = null;
    this.stepIndexToAdd = null;
    this.currentSelectedStepData = null;
  };

  setRequiredSplitProperties = () => {
    this.parentStepId = null;
    this.parentStepType = null;
    this.splitContextNodeId = null;
    this.splitContextNodeType = null;
    this.splitStepIndex = null;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <Fragment>
        <div className="row p-v-m p-h-m bg-deskera-secondary">
            <DKIcon className="mr-s ic-s-2" src={ic_info_warning} style={{ opacity: 0.7 }} />
            {i18next.t("WORKFLOW_NOTE")}
        </div>
        {this.state.showLoader ? (
          <div className="row parent-size justify-content-center align-items-center">
            <DKSpinner title="Loading Data..." />
          </div>
        ) : (
          <div
            className="parent-width parent-height border-radius-s bg-gray3 position-relative"
            style={{ overflow: "hidden" }}
          >
            <div
              className="row justify-content-between pt-l p-h-l bg-gray3 position-absolute z-index-1"
              style={{
                top: 0,
                left: 0,
              }}
            >
              <DKLabel
                text={AutomationManager.getAutomationName()}
                className="fw-m fs-l"
              />
              {this.state.steps.length > 0 && (
                <div className="row" style={{ width: "auto" }}>
                  <DKButton
                    title="Reset All"
                    className="bg-white border-m shadow-s"
                    onClick={this.resetTapped}
                  />
                  <DKButton
                    title="Save changes"
                    className="bg-button text-white ml-r"
                    onClick={() => {
                      this.saveTapped();
                    }}
                  />
                </div>
              )}
            </div>
            <div className="parent-height parent-width column align-items-center">
              {this.state.steps.length === 0 && this.renderStartTriggerButton()}
              {this.state.needAddTriggerPopup && this.renderAddTriggerPopup()}
              {this.state.needAddActionPopup && this.renderAddActionPopup()}
              {this.state.needEmailComposer && this.renderEmailComposer()}
              {this.state.needWaitEditor && this.renderWaitEditor()}
              {this.state.needFieldMapperPopup && this.renderFieldMapperPopup()}
              {this.state.needDocumentSelectionPopup && this.renderDocumentSelectionPopup()}
              {this.state.needSplitOptionPopup && this.renderSplitOptionPopup()}
              {this.state.needMessageComposer && this.renderMessageComposer()}
              {this.state.needStageChangeTrigger && this.renderStageChangeTriggerPopup()}
              {this.state.needAssignAccessPopup && this.renderAssignActionPopup()}
              {this.state.needInvoiceCommissionPopup && this.renderInvoiceCommissionPopup()}
              {this.state.needApprovalActionPopup && this.renderApprovalAction()}
              {this.state.needDateAlertCriteriaPopup && this.renderDateAlertTriggerCriteriaPopup()}
              {this.renderAllSteps()}
            </div>
            {this.state.needSavePopup && this.getSavePopup()}
          </div>
        )}
      </Fragment>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderStartTriggerButton() {
    return (
      <div
        className="border-blue shadow-m cursor-hand fw-m bg-white border-radius-r"
        style={{ marginTop: 50 }}
        onClick={() => {
          this.setAddTriggerPopupVisibility(true);
        }}
      >
        <DKLabel
          text="ADD STARTING TRIGGER"
          className="text-blue fw-m p-v-r p-h-xl"
        />
      </div>
    );
  }

  // TRIGGER ********
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderAddTriggerPopup() {
    return (
      <AddTriggerPopup
        onClose={() => this.setAddTriggerPopupVisibility(false)}
        onSelect={(triggerData) => {
          this.currentSelectedStepData = {
            ...triggerData,
          };
          switch (triggerData.type) {
              case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
              case AUTOMATION_TRIGGERS.VALUE_CHANGED:
              case AUTOMATION_TRIGGERS.CONTACT_ADDED:
              case AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED:
              case AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT:
                  this.showTriggerEditor(triggerData.type);
                  break;
              case AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED:
                  this.loadReportingManagerData();
                  break;
              default:
                  this.onSaveStep();
                  break;
          }
        }}
      />
    );
  }

  setAddTriggerPopupVisibility = (visible) => {
    this.setState({
      needAddTriggerPopup: visible,
    });
  };

  showTriggerEditor(trigger_type) {
      switch (trigger_type) {
          case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
          case AUTOMATION_TRIGGERS.VALUE_CHANGED:
          case AUTOMATION_TRIGGERS.CONTACT_ADDED:
          case AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED:
              this.toggleFieldMapperVisibility(true);
              break;
          case AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED:
              this.setStageChangePopupVisibility(true);
              break;
          case AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED:
          case AUTOMATION_TRIGGERS.EXPENSE_CREATED:
          case AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED:
              this.setAddTriggerPopupVisibility(true);
              break;
          case AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT:
              this.setDateAlertCriteriaPopupVisibility(true);
              break;
          default:
              break;
      }
  }

  setStageChangePopupVisibility = (visible) => {
    this.setState({
      needStageChangeTrigger: visible,
    });
  };

  setDateAlertCriteriaPopupVisibility = (visible) => {
    this.setState({
      needDateAlertCriteriaPopup: visible,
    });
  };

  // DOC SELECTION POPUP ********
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderDocumentSelectionPopup() {
    return (
      <DocumentSelection
        stepData={this.currentSelectedStepData}
        onClose={() => this.setDocumentSelectionPopupVisibility(false)}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.setDocumentSelectionPopupVisibility(false);
        }}
      />
    );
  }
  setDocumentSelectionPopupVisibility = (visible) => {
    this.setState({
      needDocumentSelectionPopup: visible,
    });
  };

  // ACTION ********
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderAddActionPopup() {
    return (
      <AddActionPopup
        parentStep={this.parentStepData}
        onClose={() => this.setAddActionPopupVisibility(false)}
        onSelect={(actionData) => {
          this.currentSelectedStepData = actionData;
          if (actionData.type === AUTOMATION_ACTIONS.END_WORKFLOW) {
            this.onSaveStep();
          } else {
            this.showActionEditor();
          }
        }}
      />
    );
  }

  setAddActionPopupVisibility = (visible) => {
    this.setState({
      needAddActionPopup: visible,
    });
  };

  showActionEditor() {
    const stepData = this.currentSelectedStepData;
    switch (stepData.type) {
      case AUTOMATION_ACTIONS.WAIT_FOR_TIME:
        this.setWaitEditorVisibility(true);
        break;
      case AUTOMATION_ACTIONS.SEND_EMAIL:
        this.setEmailComposerVisibility(true);
        break;
      case AUTOMATION_ACTIONS.CREATE_DEAL:
      case AUTOMATION_ACTIONS.UPDATE_DEAL:
      case AUTOMATION_ACTIONS.CREATE_CONTACT:
      case AUTOMATION_ACTIONS.UPDATE_CONTACT:
      case AUTOMATION_ACTIONS.CALCULATE_COMMISSION:
        this.toggleFieldMapperVisibility();
        break;
      case AUTOMATION_ACTIONS.SPLIT_WORKFLOW:
      case AUTOMATION_ACTIONS.DESIGNATION:
        this.toggleSplitOptionsVisibility(true);
        break;
      case AUTOMATION_ACTIONS.SEND_SMS_MESSAGE:
      case AUTOMATION_ACTIONS.SEND_WHATSAPP_MESSAGE:
        this.toggleMessageComposerVisibility(true);
        break;
      case AUTOMATION_ACTIONS.ASSIGN_ACCESS:
        this.toggleAssignActionPopupVisibility(true);
        break;
      case AUTOMATION_ACTIONS.END_WORKFLOW:
        this.setAddActionPopupVisibility(true);
        break;
      case AUTOMATION_ACTIONS.INVOICE_COMMISSION:
        this.toggleInvoiceCommissionPopupVisibility(true);
        break;
      case AUTOMATION_ACTIONS.LEAVE_APPROVAL:
      case AUTOMATION_ACTIONS.EXPENSE_APPROVAL:
        
        this.toggleApprovalActionVisibility(true);
        break;
      default:
        this.onSaveStep();
        break;
    }
  }

  // STEPS ********
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  isLinkedParentNode(childStepData) {
    const { steps, adjacencyMatrix } = this.state;

    if (childStepData?.type === AUTOMATION_ACTIONS.WAIT_FOR_TIME) {
      const adjacentKeys = adjacencyMatrix[childStepData.id];
      const nextLevelStepIndex =
        adjacentKeys?.map((childId) =>
          steps.findIndex((step) => step.id === childId)
        ) || [];

      return (
        nextLevelStepIndex[0] &&
        steps[nextLevelStepIndex[0]]?.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW
      );
    }

    return DIRECT_CHILD_ACTION_TYPES.includes(childStepData?.type);
  }

  getLinkedChildType(isDirectlyLinkedParent, childStepData) {
    if (!isDirectlyLinkedParent) return null;

    /* If a directly linked parent node is having wait action as child, 
    then it would be following an email based split action as per current flow */
    if (childStepData.type === AUTOMATION_ACTIONS.WAIT_FOR_TIME)
      return AUTOMATION_ACTIONS.SPLIT_WORKFLOW;

    return childStepData.type;
  }

  getStepWithChild(
    stepIndex,
    parentId = null,
    parentType = null,
    splitLevel = 1
  ) {
    const { adjacencyMatrix, steps } = this.state;

    const stepData = steps[stepIndex];

    if (!stepData) return null;
    this.parentStepData = steps;
    const adjacentKeys = adjacencyMatrix[stepData.id];
    const childSteps =
      adjacentKeys?.map((childId) =>
        steps.findIndex((step) => step.id === childId)
      ) || [];

    let splitDimensions = null,
      leftChild = null,
      rightChild = null,
      isDirectlyLinkedParent = false,
      linkedNodeType = null;

    if (stepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW) {
      splitDimensions = AutomationManager.getSplitStepDimensions(
        stepData.id,
        splitLevel
      );

      leftChild = this.getStepWithChild(
        childSteps[0],
        stepData.id,
        stepData.type,
        splitLevel + 1
      );

      rightChild = this.getStepWithChild(
        childSteps[1],
        stepData.id,
        stepData.type,
        splitLevel + 1
      );
    } else {
      leftChild = this.getStepWithChild(
        childSteps[0],
        stepData.id,
        stepData.type,
        splitLevel
      );

      const childStepData = steps[childSteps[0]];
      isDirectlyLinkedParent = this.isLinkedParentNode(childStepData);
      linkedNodeType = this.getLinkedChildType(
        isDirectlyLinkedParent,
        childStepData
      );
    }

    return (
      <Step
        stepIndex={stepIndex}
        stepData={stepData}
        leftChild={leftChild}
        removeAddActionOption={isDirectlyLinkedParent}
        rightChild={rightChild}
        splitDimensions={splitDimensions}
        parentType={parentType}
        onEdit={() => {
          this.stepIndexToUpdate = stepIndex;
          this.stepIndexToAdd = null;
          this.parentStepId = parentId;
          this.parentStepType = parentType;
          this.currentSelectedStepData = stepData;
          if (stepData.elementType === AUTOMATION_ELEMENT.ACTION) {
            this.showActionEditor();
          } else if (
            stepData.type === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON ||
            stepData.type === AUTOMATION_TRIGGERS.VALUE_CHANGED ||
            stepData.type === AUTOMATION_TRIGGERS.CONTACT_ADDED ||
            stepData.type === AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED ||
            stepData.type === AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT ||
            stepData.type === AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED
          ) {
            this.showTriggerEditor(stepData.type);
          } else {
            const currentStep = stepData.title?.toLowerCase() || "current trigger";
            showAlert("", `Edit operation not available on ${currentStep}.`);
          }
        }}
        onAddButtonClick={(childIndex) => {
          this.parentStepId = stepData.id;
          this.parentStepType = stepData.type;
          this.stepIndexToAdd = stepIndex;
          this.splitStepIndex = childIndex;
          this.stepIndexToUpdate = null;
          this.setAddActionPopupVisibility(true);
        }}
        onDelete={() => {
          if (stepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW) {
            this.showSplitActionDeleteWarning(stepIndex, parentId, false);
          } else if (
            isDirectlyLinkedParent &&
            stepData.type === AUTOMATION_ACTIONS.WAIT_FOR_TIME
          ) {
            showAlert(
              `Can't delete wait action?`,
              `Wait action is required. Otherwise there will be no time for your contacts to interact with the campaign/email sent.`
            );
          } else {
            this.showStepDeleteWarning(
              stepIndex,
              parentId,
              isDirectlyLinkedParent,
              linkedNodeType
            );
          }
        }}
      />
    );
  }

  renderAllSteps() {
    return (
      <div
        id="automation-step-canvas"
        className={`parent-width column align-items-${
          AutomationManager.uiJson?.outerRadiusFromLeft > 2 ? "end" : "center"
        } hide-scroll-bar`}
        style={{
          overflow: "auto",
          paddingBottom: 100,
          marginTop: 70,
          paddingTop: 20
        }}
      >
        {this.getStepWithChild(0)}
      </div>
    );
  }

  onSaveStep(isNewWaitNodeRequired) {
    if (this.stepIndexToUpdate !== null) {
      this.updateStep();
    } else {
      this.addNewStep(isNewWaitNodeRequired);
    }

    this.refreshData();
  }

  addNewStep(isNewWaitNodeRequired) {
    AutomationManager.addNewStep(
      this.currentSelectedStepData,
      this.parentStepId,
      this.stepIndexToAdd,
      this.splitStepIndex,
      isNewWaitNodeRequired
    );

    this.setAddActionPopupVisibility(false);
    this.setAddTriggerPopupVisibility(false);
    // this.scrollToBottom();
  }
  updateStep() {
    AutomationManager.updateStep(
      this.currentSelectedStepData,
      this.stepIndexToUpdate
    );

    this.setAddActionPopupVisibility(false);
    this.setAddTriggerPopupVisibility(false);
  }

  showStepDeleteWarning(index, parentId, isDirectParent, linkedNodeType) {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => {
          if (
            isDirectParent &&
            linkedNodeType === AUTOMATION_ACTIONS.SPLIT_WORKFLOW
          ) {
            this.showSplitActionDeleteWarning(index, parentId, isDirectParent);
          } else {
            AutomationManager.deleteStep(
              index,
              parentId,
              isDirectParent,
              linkedNodeType
            );
            this.refreshData();
            showToast("Action deleted...", TOAST_TYPE.SUCCESS);
          }
        },
      },
    ];

    showAlert(
      "Delete Action?",
      `Deleting this action will delete it permanently ${
        isDirectParent && linkedNodeType === AUTOMATION_ACTIONS.ASSIGN_ACCESS
          ? "along with the linked assign access action."
          : ""
      }. You can add more actions later.`,
      buttons
    );
  }

  showSplitActionDeleteWarning(index, parentId, isSplitParent) {
    showAlert(
      "Delete split paths?",
      `${
        isSplitParent
          ? "Please note, this action is linked with a split condition below. "
          : ""
      }Deleting this action will delete split paths below it permanently, are you sure to proceed further?`,
      [
        {
          title: "Cancel",
          className: "bg-gray1 border-m",
        },
        {
          title: "Delete",
          className: "bg-red text-white ml-r",
          onClick: () => {
            AutomationManager.deleteStep(
              index,
              parentId,
              isSplitParent,
              isSplitParent ? AUTOMATION_ACTIONS.SPLIT_WORKFLOW : null
            );
            this.refreshData();
            showToast("Action deleted...", TOAST_TYPE.SUCCESS);
          },
        },
      ]
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderEmailComposer() {
    let emailToOptions = null;
    /* Showing recipient options in case of sending mails in a Deal triggered workflow */
    if (this.getTriggerType() === AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED || this.getTriggerType() === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON) {
      emailToOptions = [
        { id: "Candidate", name: "Candidate" }
      ];
    }

    return (
      <EmailComposer
        stepData={this.currentSelectedStepData}
        triggerType={this.getTriggerType()}
        emailToOptions={emailToOptions}
        userList={this.props.users?.filter((user) => user.status === INVITE_USER_STATUS.JOINED)}
        onClose={() => {
          this.setEmailComposerVisibility(false);
        }}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.setEmailComposerVisibility(false);
        }}
        tableName={this.getTableName(this.getTriggerType())}
      />
    );
  }

  setEmailComposerVisibility = (visible) => {
    this.setState({
      needEmailComposer: visible,
    });
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  toggleMessageComposerVisibility = (shouldOpen) => {
    this.setState((prevState) => ({
      needMessageComposer: shouldOpen ?? !prevState.needMessageComposer,
    }));
  };

  renderMessageComposer() {
    return (
      <MessageComposer
        stepData={this.currentSelectedStepData}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.toggleMessageComposerVisibility(false);
        }}
        onClose={() => this.toggleMessageComposerVisibility(false)}
      />
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  renderWaitEditor() {
    return (
      <WaitEditor
        stepData={this.currentSelectedStepData}
        onClose={() => {
          this.setWaitEditorVisibility(false);
        }}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.setWaitEditorVisibility(false);
        }}
      />
    );
  }

  getTableName(type) {
    switch (type) {
        case AUTOMATION_ACTIONS.CREATE_CONTACT:
        case AUTOMATION_ACTIONS.UPDATE_CONTACT:
        case AUTOMATION_TRIGGERS.VALUE_CHANGED:
        case AUTOMATION_TRIGGERS.CONTACT_ADDED:
        case AUTOMATION_ACTIONS.CALCULATE_COMMISSION:
            return TABLES.CANDIDATE;
        case AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT:
        case AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED:
            return TABLES.EMPLOYEE_LIST;
        default:
            return TABLES.DEAL;
    }
  }

  renderFieldMapperPopup() {
    return (
      <FieldMapper
        tableName={this.getTableName(this.currentSelectedStepData.type)}
        onSave={this.onFieldMapperSave}
        onClose={this.toggleFieldMapperVisibility}
        parentStepType={this.parentStepType}
        stepData={this.currentSelectedStepData}
      />
    );
  }

  setWaitEditorVisibility = (visible) => {
    this.setState({
      needWaitEditor: visible,
    });
  };
  toggleFieldMapperVisibility = (visible = null) => {
    if (visible === null) visible = !this.state.needFieldMapperPopup;
    this.setState({
      needFieldMapperPopup: visible,
    });
  };
  onFieldMapperSave = (fieldsData, logicalOperator) => {
    this.currentSelectedStepData["configuration"] = { fields: fieldsData };
    this.currentSelectedStepData["logicalOperator"] = logicalOperator;
    this.onSaveStep();
    this.toggleFieldMapperVisibility();
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  toggleSplitOptionsVisibility = (shouldOpen = null) => {
    this.splitContextNodeId = this.parentStepId;
    this.splitContextNodeType = this.parentStepType;

    /* Setting correct splitContextNode data before opening split conf popup */
    if (shouldOpen) {
      const { steps, adjacencyMatrix } = this.state;

      if (this.splitContextNodeType === AUTOMATION_ACTIONS.WAIT_FOR_TIME) {
        const waitParentId = Object.keys(adjacencyMatrix).find((parentKey) =>
          adjacencyMatrix[parentKey]?.includes(this.parentStepId)
        );

        const waitParentStepData = waitParentId
          ? steps.find((stepData) => stepData.id === waitParentId)
          : null;

        /* Wait is only supported below campaign or send email type automation element, for splitting conditions. */
        if (
          waitParentStepData &&
          (SPLIT_ACTION_TYPE_CONTEXT[SPLIT_ACTION_TYPE.EMAIL_OPENED].includes(
            waitParentStepData.type
          ) ||
            SPLIT_ACTION_TYPE_CONTEXT[
              SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED
            ].includes(waitParentStepData.type))
        ) {
          this.splitContextNodeId = waitParentId;
          this.splitContextNodeType = waitParentStepData.type;
        }
      }

      if (
        UNSUPPORTED_SPLIT_CONTEXT_ACTIONS.includes(this.splitContextNodeType)
      ) {
        showAlert(
          `Can't add split node?`,
          `Split action is not supported with ${this.splitContextNodeType
            .replaceAll("_", " ")
            .toLowerCase()} action.`
        );

        return;
      }
    }

    this.setState((prev) => ({
      needSplitOptionPopup: shouldOpen ?? !prev.needSplitOptionPopup,
    }));
  };

  getTriggerType = () => {
    if(this.triggerType) return this.triggerType;

    const triggerData = this.state.steps.find((step) => step.elementType === AUTOMATION_ELEMENT.TRIGGER);
    this.triggerType = triggerData?.type;
    return triggerData?.type;
  }

  renderSplitOptionPopup() {
    return (
      <SplitActionPopup
        stepData={this.currentSelectedStepData}
        parentStepId={this.splitContextNodeId}
        parentStepType={this.splitContextNodeType}
        onSave={(config, isEmailType) => {
          this.currentSelectedStepData["configuration"] = config;
          const isWaitNodeRequired =
            isEmailType &&
            this.parentStepType !== AUTOMATION_ACTIONS.WAIT_FOR_TIME;
          this.onSaveStep(isWaitNodeRequired);
          this.toggleSplitOptionsVisibility();
        }}
        onClose={this.toggleSplitOptionsVisibility}
      />
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  toggleAssignActionPopupVisibility = (shouldOpen = null) => {
    const allowActionAdd = SUPPORTED_ASSIGN_ACCESS_ELEMENTS.includes(
      this.parentStepType
    );

    if (shouldOpen && !allowActionAdd && this.stepIndexToUpdate === null) {
      showAlert(
        `Can't add action?`,
        `Assign record access action is not supported with above action/trigger.`
      );

      return;
    }

    this.setState((prevState) => ({
      needAssignAccessPopup: shouldOpen ?? !prevState.needAssignAccessPopup,
    }));
  };

  renderAssignActionPopup = () => {
    return (
      <AssignAccessActionPopup
        stepData={this.currentSelectedStepData}
        parentStepType={this.parentStepType}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.toggleAssignActionPopupVisibility(false);
          this.onSaveStep();
        }}
        onClose={() => this.toggleAssignActionPopupVisibility(false)}
      />
    );
  };

  renderStageChangeTriggerPopup() {
    return (
      <StageChangeTriggerPopup
        stepData={this.currentSelectedStepData}
        onClose={() => this.setStageChangePopupVisibility(false)}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.setStageChangePopupVisibility(false);
        }}
      />
    );
  }

  renderDateAlertTriggerCriteriaPopup() {
    return (
      <DateAlertCriteriaPopup
        stepData={this.currentSelectedStepData}
        onClose={() => this.setDateAlertCriteriaPopupVisibility(false)}
        onSave={(data) => {
          this.currentSelectedStepData["configuration"] = data;
          this.onSaveStep();
          this.setDateAlertCriteriaPopupVisibility(false);
        }}
      />
    );
  }

  scrollToBottom() {
    setTimeout(() => {
      const canvas_holder = document.getElementById("automation-step-canvas");
      canvas_holder.scrollTop = 20000;
    }, 10);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  resetTapped = () => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Reset",
        className: "bg-red text-white ml-r",
        onClick: () => {
          AutomationManager.resetAllData();
          this.refreshData();
          /* Reset Split type properties */
          this.setRequiredSplitProperties();
        },
      },
    ];

    showAlert(
      "Reset all actions?",
      "Deleting this actions will delete it permanently. This automation will be reset.",
      buttons
    );
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  saveTapped = () => {
    AutomationManager.setupSplitActionConfigurations();
    this.refreshData();
    if (AutomationManager.isDataAvailable()) {
      this.showUpdateAlert();
    } else {
      this.showSavePopup();
    }
    this.updateTenantTimezone();
  };

  updateTenantTimezone = () => {
    const { tenant } = TenantManager.getPeopleTenantData()
    tenant['companyTimeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    CompanyDetailService.updateCompanyDetail(tenant).then(
        (response) => {
          if (response && response.status === "OK") {
              TenantManager.setPeopleTenantData(response);
          }
        }, (err) => {
          console.log("Unable to update tenant time zone");
        }
    )
}

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSavePopup() {
    return (
      <SavePopup
        title="New automation"
        header="Automation Name"
        headerIcon="📝 "
        subHeader="Enter a name to help you remember what this automation is all about."
        onCancel={this.onPopupCancel}
        onSave={this.onPopupSave}
        allowDomainSelection={false}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSavePopup = () => {
    let needSavePopup = true;
    const trigger = AutomationManager.steps.find((s) => s.elementType === AUTOMATION_ELEMENT.TRIGGER);
    if (trigger.type === AUTOMATION_TRIGGERS.EXPENSE_CREATED) {
        if (!AutomationManager.steps.find((s) => s.type === AUTOMATION_ACTIONS.EXPENSE_APPROVAL)) {
            needSavePopup = false;
            showAlert("Alert", "Please add expense approval action.");
        }
    } else if(trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
        if (!AutomationManager.steps.find((s) => s.type === AUTOMATION_ACTIONS.LEAVE_APPROVAL)) {
            needSavePopup = false;
            showAlert("Alert", "Please add Time Off approval action.");
        }
    }

    if (!AutomationManager.steps.find((s) => s.type === AUTOMATION_ACTIONS.END_WORKFLOW)) {
        needSavePopup = false;
        showAlert("Alert", "Please add end automation action.");
    }

    this.setState({
        needSavePopup: needSavePopup,
    });
  };
  hideSavePopup = () => {
    this.setState({
      needSavePopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onPopupSave = ( title, domain ) => {
    this.hideSavePopup();
    this.saveAutomation(title);
  };
  onPopupCancel = () => {
    this.hideSavePopup();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  saveAutomation(title) {
    let json_data = Utility.encodeJSON({
      steps: AutomationManager.steps,
      adjacencyMatrix: AutomationManager.adjacencyMatrix,
    });

    let data = {
      json: json_data,
      name: title,
    };

    const request = AutomationManager.getRequestToSave(data);
    AutomationService.save(
      request,
      (data) => {
        this.automationSaved(data, true);
      },
      (error) => {}
    );
  }

    showUpdateAlert() {
        const trigger = AutomationManager.steps.find((s) => s.elementType === AUTOMATION_ELEMENT.TRIGGER);
        if (trigger.type === AUTOMATION_TRIGGERS.EXPENSE_CREATED || trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
            if (AutomationManager.steps.find((s) => s.type === AUTOMATION_ACTIONS.EXPENSE_APPROVAL) || AutomationManager.steps.find((s) => s.type === AUTOMATION_ACTIONS.LEAVE_APPROVAL)) {
                let msg = `All the pending expenses will be updated with given approval levels. Are you sure want to continue?`;
                if (trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
                    msg = `All the pending time off will be updated with given approval levels. Are you sure want to continue?`;
                }

                showAlert("Alert", msg,
                    [{
                        title: "Continue",
                        className: "bg-gray1 border-m",
                        onClick: () => {
                            this.updateAutomation(true, trigger);
                        }
                    },
                    {
                        title: "Cancel",
                        className: "bg-button text-white ml-r",
                        onClick: () => {
                            return;
                        }
                    }]
                );
            } else {
                let msg = `Please add expense approval action.`;
                if (trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
                    msg = `Please add time off approval action.`;
                }
                showAlert("Alert", msg);
            }
        } else {
            this.updateAutomation(false, trigger);
        }
    }

  updateAutomation(isUpdatePendingApprovalDocuments, trigger) {
    const json_data = Utility.encodeJSON({
        steps: AutomationManager.steps,
        adjacencyMatrix: AutomationManager.adjacencyMatrix,
    });

    const data = {
        json: json_data,
    };

    const request = AutomationManager.getRequestToUpdate(data);
    AutomationService.update(
        request,
        AutomationManager.getRecordId(),
        (data) => {
            this.automationSaved(data, false);
            if (isUpdatePendingApprovalDocuments) {
                this.updateExpenses();
            }
        },
        (error) => { }
    );
  }

  updateExpenses() {
    const { data } = AutomationManager.getData();
    if (data.cells) {
        const automationId = data.cells[AutomationManager.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID)];
        const spendDate = data.cells[AutomationManager.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.CREATED_AT)];

        const params = {
            automationId: automationId,
            spendDate: Utility.formatDate(spendDate, DATE_FORMAT.YYYYMMDD, DATE_FORMAT.YYYYMMDD)
        };

        AutomationService.updateExpenses(params, undefined).then(
            (response) => {
                if (Array.isArray(response) && response.length > 0) {
                    showToast("Updated expenses successfully.", TOAST_TYPE.SUCCESS);
                }
            }, (error) => {
                showToast("Error while updating expenses", TOAST_TYPE.FAILURE);
            }
        );
    }
  }

  updateTimeoff() {
    const { data } = AutomationManager.getData();
    if (data.cells) {
        const params = {
            automationId: data.cells[AutomationManager.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID)]
        };

        AutomationService.updateTimeoff(params, undefined).then(
            (response) => {
                if (Array.isArray(response) && response.length > 0) {
                    showToast("Updated time off successfully.", TOAST_TYPE.SUCCESS);
                }
            }, (error) => {
                showToast("Error while updating time off", TOAST_TYPE.FAILURE);
            }
        );
    }
  }

  automationSaved(data, isNew) {
    // store.dispatch(fetchRecordsByTable({ tableName: TABLES.AUTOMATION }));

    if (isNew) {
      AutomationManager.setData(data);
      RouteManager.navigateToPage(
        PAGE_ROUTES.AUTOMATION_BUILDER + "/" + AutomationManager.getRecordId()
      );
    }

    const buttons = [
      {
        title: "Stay on page",
        className: "bg-gray1 border-m",
        onClick: () => {
          this.refreshData();
        },
      },
      {
        title: "Go to Home",
        className: "bg-button text-white ml-r",
        onClick: () => {
          RouteManager.navigateToPage(PAGE_ROUTES.AUTOMATION);
        },
      },
    ];
    showAlert(
      isNew ? "Data saved!" : "Data updated!",
      isNew
        ? "Automation has been saved & activated successfully."
        : "Automation has been updatd successfully.",
      buttons
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  hideUnHideLoader(flag = null) {
    if (flag === null) flag = !this.state.showLoader;
    this.setState({
      showLoader: flag,
    });
  }

  toggleInvoiceCommissionPopupVisibility(shouldOpen) {
    this.setState({
        needInvoiceCommissionPopup: shouldOpen
    });
  }

  toggleApprovalActionVisibility = (shouldOpen) => {
    if (!SUPPORTED_APPROVAL_CONDITIONS_ACTIONS.includes(this.parentStepType)) {
      showAlert(
        `Can't add approval condition here`,
        `Approval condition is not supported for selected trigger.`
      );

      return;
    }
    this.setState((prevState) => ({
      needApprovalActionPopup: shouldOpen ?? !prevState.needApprovalActionPopup
    }));
  };

  renderInvoiceCommissionPopup() {
    return (
        <InvoiceCommissionAction
            stepData={this.currentSelectedStepData}
            onClose={() => this.toggleInvoiceCommissionPopupVisibility(false)}
            onSave={(fields, logicalOperator) => {
                this.currentSelectedStepData["configuration"] = { fields: fields };
                this.currentSelectedStepData["logicalOperator"] = logicalOperator;
                this.toggleInvoiceCommissionPopupVisibility(false)
                this.onSaveStep();
            }}
        />
    )
  }

  renderApprovalAction() {
    return (
      <ApprovalActionPopup
        stepData={this.currentSelectedStepData}
        parentStepId={this.parentStepId}
        parentStepType={this.parentStepType}
        onSave={(config, isEmailType) => {
          this.currentSelectedStepData['configuration'] = config;
          const isWaitNodeRequired =
            isEmailType &&
            this.parentStepType !== AUTOMATION_ACTIONS.WAIT_FOR_TIME;
          this.onSaveStep(isWaitNodeRequired);
          this.toggleApprovalActionVisibility(false);
        }}
        onClose={this.toggleApprovalActionVisibility}
      />
    );
  }

  async loadReportingManagerData() {
    showLoader();
    try {
      await this.props.fetchEmployeeListWithoutFilter();
      if (this.props.allEmployees) {
        const reportingManagers = getReportingManagerOptions(this.props.allEmployees, null, false);
        EmployeeManager.setReportingManagers(reportingManagers);
        this.showTriggerEditor(AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED);
      }
      removeLoader();
    } catch (err) {
      removeLoader();
      EmployeeManager.setReportingManagers([]);
      showAlert("Error Occurred!", "Failed to fetch reporting managers.");
    }
  }
}

const mapStateToProps = (state) => ({
	allEmployees: state?.employee?.formData?.employeeDetails || null
});

const mapDispatchToProps = (dispatch) => ({
  fetchEmployeeListWithoutFilter: () => dispatch(fetchEmployeeListWithoutFilter())
});

export default connect(mapStateToProps, mapDispatchToProps)(AutomationBuilder);
